"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styles = {
    container: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '0.55px solid #c7c7c7',
        borderRadius: '5px',
        userSelect: 'none',
        backgroundColor: '#18ce0f14',
        fontSize: '10px',
        color: '#00801d',
        margin: '0px 5px',
        cursor: 'ew-resize',
    },
    label: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        maxWidth: '100%',
        paddingLeft: '5px',
        paddingRight: '5px',
    },
};
// TODO: remove this hacky ref usage.
function InputRange(props, ref) {
    const { name, value = 0, onChange, label, shortLabel, style, className, } = props;
    const previousPosition = (0, react_1.useRef)(0);
    const valueRef = (0, react_1.useRef)(value);
    (0, react_1.useImperativeHandle)(ref, () => ({
        setValue: (value) => {
            valueRef.current = value;
        },
    }));
    const mouseDownCallback = (0, react_1.useCallback)((event) => {
        function mouseMoveCallback(event) {
            const diff = event.clientX - previousPosition.current;
            previousPosition.current = event.clientX;
            if (event.buttons === 1) {
                const step = diff / (event.shiftKey ? 10 : 1);
                valueRef.current = valueRef.current + step;
                onChange({
                    value: valueRef.current,
                    name,
                });
            }
        }
        function mouseUpCallback() {
            window.removeEventListener('mousemove', mouseMoveCallback);
            window.removeEventListener('mouseup', mouseUpCallback);
        }
        previousPosition.current = event.clientX;
        window.addEventListener('mousemove', mouseMoveCallback);
        window.addEventListener('mouseup', mouseUpCallback);
    }, [name, onChange]);
    return ((0, jsx_runtime_1.jsxs)("div", { style: { ...styles.container, ...style }, ...(className && { className }), onMouseDown: mouseDownCallback, children: [(0, jsx_runtime_1.jsx)("span", { className: shortLabel ? 'large-label' : '', style: styles.label, children: label }), shortLabel && ((0, jsx_runtime_1.jsx)("span", { className: "small-label", style: styles.label, children: shortLabel }))] }));
}
exports.default = (0, react_1.forwardRef)(InputRange);
